// React
import React from 'react';
import { Card, Typography } from '@material-ui/core';
import { Description } from '@material-ui/icons';
// componentes
import { useStyles } from "./style";

export default function ComponenteMostrarEstadisticas (props) {
    const classes = useStyles();

    return (
        <div className={classes.contenedor}>
            <Card className={classes.contenedorCard}>
                <div className={classes.cardContent}>
                    <Description className={classes.iconGeneradas}/>
                    <Typography className={classes.typographyTitulo} variant="subtitle2" gutterBottom>Generadas</Typography>
                    <Typography className={classes.typographyTotales} variant="body2" gutterBottom>{props.datosEstadistica.generados}</Typography>
                </div>
            </Card>
            <Card className={classes.contenedorCard}>
                <div className={classes.cardContent}>
                    <Description className={classes.iconPendientes}/>
                    <Typography className={classes.typographyTitulo} variant="subtitle2" gutterBottom>Pendientes</Typography>
                    <Typography className={classes.typographyTotales} variant="body2" gutterBottom>{props.datosEstadistica.pendientes}</Typography>
                </div>
            </Card>
        </div>
    )
}